import { useEffect, useState } from "react";

export const ValidationTypes = {
  stringMinLength: "stringMinLength",
  stringMaxLength: "stringMaxLength",
  arrayMinLength: "arrayMinLength",
  arrayMaxLength: "arrayMaxLength",
  stringRequired: "stringRequired",
  objectRequired: "objectRequired",
  onlyPersianCharacters: "onlyPersianCharacters",
  onlyStartsWith021: "onlyStartsWith021",
  onlyStartsWithout09: "onlyStartsWithout09",
};

export const ValidationMessage = {
  [ValidationTypes.stringMinLength]: ({ label }, { options: { length } }) =>
    `حداقل طول ${label} باید ${length} کارکتر باشد`,
  [ValidationTypes.stringMaxLength]: ({ label }, { options: { length } }) =>
    `حداکثر طول ${label} باید ${length} کارکتر باشد`,
  [ValidationTypes.arrayMinLength]: ({ label }, { options: { length } }) =>
    `حداقل تعداد ${label} باید ${length}باشد`,
  [ValidationTypes.arrayMaxLength]: ({ label }, { options: { length } }) =>
    `حداکثر تعداد ${label} باید ${length}باشد`,
  [ValidationTypes.stringRequired]: ({ label }) =>
    `مقدار ${label} نمی تواند خالی باشد`,
  [ValidationTypes.objectRequired]: ({ label }) =>
    `مقدار ${label} نمی تواند خالی باشد`,
  [ValidationTypes.onlyPersianCharacters]: ({ label }) =>
    `مقدار ${label} باید فقط شامل حروف فارسی باشد`,
  [ValidationTypes.onlyStartsWith021]: ({ label }) =>
    `"لطفا در قسمت ساختار دستگاه ، استانی را انتخاب نمایید.`,
  [ValidationTypes.onlyStartsWithout09]: ({ label }) =>
    `"لطفا شماره تلفن ثابت خود را وارد نمایید.`,
};

const validationHandler = {
  [ValidationTypes.arrayMaxLength]: ({ value }, { options: { length } }) =>
    Array.isArray(value) && value.length <= length,
  [ValidationTypes.arrayMinLength]: ({ value }, { options: { length } }) =>
    Array.isArray(value) && value.length >= length,
  [ValidationTypes.stringMinLength]: ({ value }, { options: { length } }) =>
    value?.length >= length,
  [ValidationTypes.stringMaxLength]: ({ value }, { options: { length } }) => {
    console.log({ value }, { length });
    return value?.length <= length;
  },
  [ValidationTypes.stringRequired]: ({ value }) =>
    !!value?.toString()?.replace(/\s+/gi, " ")?.trim(),
  [ValidationTypes.objectRequired]: ({ value }) =>
    Object.keys(value ?? {}).length > 0,
  [ValidationTypes.onlyPersianCharacters]: ({ value }) =>
    !value || /^[\u0600-\u06FF\s]+$/.test(value),
  [ValidationTypes.onlyStartsWith021]: ({ value }) => {
    return !value || value.startsWith("021");
  },
  [ValidationTypes.onlyStartsWithout09]: ({ value }) => {
    return !value || !value.startsWith("09");
  },
};

export const useValidation = (validationInput) => {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrorList = {};

    for (const input of validationInput) {
      let errorMessage = [];
      for (const validationType of input.validations) {
        const isValid = validationHandler[validationType.type]?.(
          input,
          validationType,
        );

        if (!isValid) {
          errorMessage.push(
            validationType.message ??
              ValidationMessage[validationType.type]?.(input, validationType),
          );
        }
      }

      if (errorMessage.length > 0) {
        newErrorList[input.name] = errorMessage.join(" ,");
      }
    }

    setErrors(newErrorList);

    return {
      errors: newErrorList,
      isValid: Object.keys(newErrorList).length === 0,
    };
  };

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
    validate,
    removeError(name) {
      const newErrorList = { ...errors };
      delete newErrorList[name];
      setErrors(newErrorList);
    },
  };
};
